import { cn, DeviceTypeDetectionVariant, useDeviceTypeDetection } from '@crossnokaye/ux-common';

interface PageContentContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export const PageContentContainer = ({
  children,
  className,
  ...props
}: PageContentContainerProps) => {
  const { isMobile } = useDeviceTypeDetection({
    variant: DeviceTypeDetectionVariant.DeviceOnly,
  });

  return (
    <div
      className={cn('@container/page-content relative min-w-0 h-full', {
        'mb-gutter-sm': isMobile,
      })}
      {...props}
    >
      {children}
    </div>
  );
};
